"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericCacheService = void 0;
class GenericCacheService {
    constructor(cacheKeyGetter) {
        this._cacheKeyGetter = cacheKeyGetter;
        this._cacheData = new Map();
    }
    get(key) {
        return this._cacheData.get(key);
    }
    set(key, data) {
        this._cacheData.set(key, data);
    }
    getKey(data) {
        if (!this._cacheKeyGetter) {
            throw Error("No cacheKeyGetter function specified");
        }
        return this._cacheKeyGetter(data);
    }
    invalidate() {
        this._cacheData = new Map();
    }
}
exports.GenericCacheService = GenericCacheService;
//# sourceMappingURL=GenericCacheService.js.map